import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Why is alt text important?",
    answer: "Alt text is crucial for web accessibility and SEO. It helps visually impaired users understand images through screen readers, and helps search engines index your images properly. Good alt text can improve your site's accessibility compliance and search engine rankings."
  },
  {
    question: "How does the AI-powered generation work?",
    answer: "Our advanced AI technology analyzes your images to generate accurate, descriptive alt text and detailed image descriptions. The system is trained to create both concise alt tags for accessibility and detailed descriptions for better context."
  },
  {
    question: "Can I customize the generated alt text?",
    answer: "Yes! You can edit and refine the generated alt text and descriptions to match your specific needs while maintaining accessibility best practices."
  },
  {
    question: "What file formats are supported?",
    answer: "We support JPEG, PNG, and WebP image formats. Each image should be under 5MB in size for optimal processing."
  },
  {
    question: "Can I export the generated content?",
    answer: "Yes! You can export all generated alt text and descriptions in CSV format, making it easy to implement across your website or content management system."
  }
];

export const FAQ = () => {
  return (
    <section className="py-20 bg-sage-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-sage-800">
          Frequently Asked Questions
        </h2>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="bg-white rounded-lg">
                <AccordionTrigger className="px-6 hover:no-underline">
                  <span className="text-left font-semibold text-sage-800">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-sage-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};